import 'core-js/modules/es.promise.finally';

let p = (window as any).Promise;
Object.defineProperty(window, 'Promise', {
  get: function() {
    return p;
  },
  set: function(newValue) {
    if (newValue.prototype && !newValue.prototype.finally) {
      newValue.prototype.finally = p.prototype.finally;
    }
    p = newValue;
  },
  enumerable: true,
  configurable: true
});
